import { WidgetHeaderTimer } from '@frontend/ui-library';

import useCountdown from '../../hooks/useCountdown';

export interface WidgetHeaderRateTimerProps {
  expiresAt: number;
}

export default function WidgetHeaderRateTimer({
  expiresAt,
}: WidgetHeaderRateTimerProps): JSX.Element {
  const { hours, minutes, seconds } = useCountdown({
    endDate: expiresAt * 1000,
  });

  const time = `${
    !!hours && hours !== '00' ? `${hours}:` : ''
  }${minutes}:${seconds}`;

  return <WidgetHeaderTimer description="Rate valid for:" time={time} />;
}
